import { render, staticRenderFns } from "./CommonTextDialog.vue?vue&type=template&id=442a464c&scoped=true"
import script from "./CommonTextDialog.vue?vue&type=script&lang=js"
export * from "./CommonTextDialog.vue?vue&type=script&lang=js"
import style0 from "./CommonTextDialog.vue?vue&type=style&index=0&id=442a464c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442a464c",
  null
  
)

export default component.exports